module.exports = __webpack_public_path__ + "img/a-case-of-you.81ccf1da.jpeg";